import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyReviewsUpdateEvent
 *
 * - Evento emitido quando uma revisão é atualizada no meu espaço.
 */
export class MySpaceMyReviewsUpdateEvent extends CreateCommand(
  RealtimeEventType.MySpaceMyReviewsUpdate,
  SCHEMA,
) {}
